import {Injectable} from "@angular/core";
import {filter, map, Subject, Subscription} from "rxjs";
import {SessionStorageService} from "./sessionstorage.service";

@Injectable({ providedIn: 'root' })
export class EventService {
    private subject$ = new Subject<EventData>();

    constructor(private storage: SessionStorageService) { }

    emit(event: EventData) {
        this.subject$.next(event);
        this.storage.saveData('lastEvent', { dt: new Date(), event: event });
    }

    on(eventName: string, action: any): Subscription {
        return this.subject$.pipe(
            filter((e: EventData) => e.name === eventName),
            map((e: EventData) => e["value"])).subscribe(action);
    }
}

export class EventData {
    name: string;
    value: any;

    constructor(name: string, value: any) {
        this.name = name;
        this.value = value;
    }
}
